export enum Icon {
  Highway = 'highway',
  OilBarrel = 'oil-barrel',
  Excavator = 'excavator',
  Route = 'route',
  Truck = 'truck',
  Building = 'building',
  Gasoline = 'gasoline',
  Member = 'member',
  User = 'user',
  Email = 'email',
  Administration = 'administration',
  Statistic = 'statistic',
  Energy = 'energy',
  Industry = 'industry',
  UserEntities = 'user-entities',
  Sigma = 'sigma',
  RadarChart = 'radar',
  Youtube = 'youtube',
  Structures = 'structures',
  List = 'list',
  ExcavatorSettings = 'excavatorSettings',
  ExcavatorSigma = 'excavatorSigma',
  TruckSettings = 'truckSettings',
  Water = 'water',
  Checklist = 'checklist',
  Dashboard = 'dashboard',
  Help = 'help',
  Key = 'key'
}
